<template>
	<div id="app">
		<router-view id="content" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'App',
	computed: {
		...mapGetters(['user']),
	},
	watch: {
		$route(to) {
			const query = Object.assign({}, to.query);
			this.$store.commit('SETUP_URL_SETTINGS', query);
		},
	},
};
</script>
